import React, { type ComponentProps, type HTMLProps } from 'react';

import { FloatingArrow as FloatingUIArrow } from '@floating-ui/react';

import {
    FLOATING_ARROW_HEIGHT,
    FLOATING_ARROW_TIP_RADIUS,
    FLOATING_ARROW_WIDTH
} from './Floating.constants';
import { useFloatingContext } from './Floating.context';
import { getFixedArrowPositionStyles } from './Floating.utils';

export type FloatingArrowProps = Omit<ComponentProps<typeof FloatingUIArrow>, 'context'> &
    HTMLProps<HTMLDivElement>;

export const FloatingArrow = ({
    style,
    width = FLOATING_ARROW_WIDTH,
    height = FLOATING_ARROW_HEIGHT,
    tipRadius = FLOATING_ARROW_TIP_RADIUS,
    ...props
}: FloatingArrowProps) => {
    const { arrowRef, ...context } = useFloatingContext();
    const customStyle = {
        ...style,
        ...getFixedArrowPositionStyles(context.placement)
    };
    return (
        <FloatingUIArrow
            width={width}
            height={height}
            tipRadius={tipRadius}
            context={context as never}
            ref={arrowRef}
            style={customStyle}
            data-testid="floating-arrow"
            {...props}
        />
    );
};

FloatingArrow.displayName = 'FloatingArrow';
